<template>
    <div>
        <Header title="消息"/>
        <van-tabs color="#7181EB" title-active-color="#7181EB" v-model="active">
            <van-tab
                v-for="(item, index) in navArray"
                :key="index"
                :title="item.title"
            >
                <notice-tab
                    :item="item"
                    :type="item.type"
                />
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import Header from '@/components/Header'
import NoticeTab from '@/components/notice/NoticeTab'
export default {
    components: {
        Header,
        NoticeTab,
    },
    setup() {
        const active = 0;
        return { active };
    },
    data() {
        return {
            loading: false,
            navArray: [
                {title: '平台公告', type: this.Constants.MSG_SYS},
                {title: '我的消息', type: this.Constants.MSG_MY},
            ],
            type: '',
            active: 0,
            wrapperHeight: 0, //屏幕高度 - 脚部
            page: 1,
            limit: 10,
            dataSource1: [],
            dataSource2: [],
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    methods: {
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}
</style>